export const baseUrl = process.env.REACT_APP_BASE_URL;




// WEBPACK FOOTER //
// ./src/helper/ApiCall.jsx